<template>
  <div>
    <span :class="isSelected? 'selectedNameText': 'unSelectedNameText'" v-if="!useShortName">{{ unit.name }}</span>
    <span :class="isSelected? 'selectedNameText': 'unSelectedNameText'" v-if="useShortName">{{ unit.shortName }}</span>
    <v-chip cursor="pointer" color="blue" class="darken-4" text-color="white" disabled>{{ chipText }}</v-chip>
  </div>
</template>

<script>
export default {
  name: 'UnitNavigationTile',
  data() {
    return {};
  },
  props: ['isSelected', 'unit', 'useShortName'],
  computed: {
    chipText() {
      let returnValue = 'n/a';
      if (this.unit && this.unit.rooms && this.unit.rooms.length > 0) {
        const filledCount = this.unit.rooms.reduce((stayCount, room) => {
          let val = stayCount;
          if (room.stays) {
            val = stayCount + this.$store.getters.getRoomFilledCount(room);
          }
          return val;
        }, 0);
        returnValue = `${filledCount}/${this.unit.maximumOccupancyCount}`;
      }
      return returnValue;
    },
    nameText() {
      let returnValue = this.unit.name;
      if (this.useShortName) {
        returnValue = this.unit.shortName;
      }
      return returnValue;
    }
  }
};
</script>

<style lang="scss">
.selectedNameText {
  color: #333333;
  font-weight: 700;
}
.unSelectedNameText {
  color: #666666;
  font-weight: 500;
}
</style>
